import { Flex, Skeleton } from 'ui';

const skeletonItemCount = 3;

const ChatSidebarSkeleton = () => (
  <Flex paddingHorizontal="xs" paddingVertical="xxxs" vertical>
    {Array.from({ length: skeletonItemCount }, (_, index) => (
      <Flex align="center" gap="xs" key={`chat-sidebar-skeleton-item-${index}`}>
        <Skeleton.Avatar active shape="circle" size="large" />
        <Flex flex={1} vertical>
          <Skeleton active paragraph={{ rows: 2 }} title={false} />
        </Flex>
      </Flex>
    ))}
  </Flex>
);

export default ChatSidebarSkeleton;
